
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Report_Adv01Dialog extends Serenity.EntityDialog<Report_Adv01Row, any> {
        protected getFormKey() { return Report_Adv01Form.formKey; }
        protected getIdProperty() { return Report_Adv01Row.idProperty; }
        protected getLocalTextPrefix() { return Report_Adv01Row.localTextPrefix; }
        protected getNameProperty() { return Report_Adv01Row.nameProperty; }
        protected getService() { return Report_Adv01Service.baseUrl; }
        protected getDeletePermission() { return Report_Adv01Row.deletePermission; }
        protected getInsertPermission() { return Report_Adv01Row.insertPermission; }
        protected getUpdatePermission() { return Report_Adv01Row.updatePermission; }

        protected form = new Report_Adv01Form(this.idPrefix);

    }
}